var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnterprise = function SvgEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    height: 20,
    width: 20,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3cb678",
    fillOpacity: 1,
    d: "M255.97 0L180.99 74.978H75.01v106.044L.03 256l74.978 74.978v106.044H180.99L255.97 512l74.978-74.978h106.044V330.978L511.97 256l-74.978-74.978V74.978H330.947z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 1,
    fillOpacity: 1,
    d: "M355.164 160.502L225.81 289.332l-68.848-69.123-31.145 31.018 99.866 100.271 160.5-159.852z"
  })));
};
export default SvgEnterprise;